let productData = [
    {
        id: 1,
        name: "Edifier Hecate G5BT Cat Pink Wireless Gaming Headphone",
        img: "assets/images/product.webp",
        rating: 4.5,
        brand: "Edifier ",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 1500, 
        feature: true,
    },
    {
        id: 2,
        name: " TRINITY MH88 Sakura  Multiplatform Gaming Headset",
        img: "assets/images/product1.webp",
        rating: 4.5,
        brand: "Sakura",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 1300,
        feature: true,
    },
    {
        id: 3,
        name: "A4TECH BH300 Bluetooth Wireless Headset",
        img: "assets/images/product2.webp",
        rating: 4.5,
        brand: "A4TECH",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 2000,
        feature: false,
    },
    {
        id: 4,
        name: "A4TECH Bloody G600I Virtual 7.1  Gaming Headphone",
        img: "assets/images/product4.jpg",
        rating: 4,
        brand: "A4TECH",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 3600,
        feature: false,
    },
    {
        id: 5,
        name: "Lenovo Thinkplus K3 Mini Bluetooth Speaker",
        img: "assets/images/product5.webp",
        rating: 4.5,
        brand: "Lenovo",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 600,
        feature: false,
    },
    {
        id: 6,
        name: "Lenovo Thinkplus K3 Plus RGB Portable Bluetooth Speaker",
        img: "assets/images/product6.webp",
        rating: 4.5,
        brand: "Lenovo",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 500,
        feature: false,
    },
    {
        id: 7,
        name: "Amazon Smart Speaker With Clock and Alexa",
        img: "assets/images/product7.jpg",
        rating: 4.5,
        brand: "Amazon",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 1500,
        feature: false,
    },
    {
        id: 8,
        name: " Wireless Bluetooth Speaker + Usb - Microlab Speaker",
        img: "assets/images/productimg.png",
        rating: 4.5,
        brand: "Zara",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 145,
        feature: false,
    },
    {
        id: 9,
        name: "Soft Body Set of 3 Luggage - Supreme Combo Set (30inch+26inch+22inch) - Black",
        img: "assets/images/product13.webp",
        rating: 4.5,
        brand: "Metronaut",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 4000, 
        feature: false,
    },
    {
        id: 10,
        name: "Soft Body Set of 3 Luggage - Supreme Combo Set (30inch+26inch+22inch) - Black",
        img: "assets/images/product10.webp",
        rating: 4.5,
        brand: "Metronaut",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 3750,
        feature: false,
    },
    {
        id: 11,
        name: "Soft Body Set of 3 Luggage - Supreme Combo Set (30inch+26inch+22inch) - Black",
        img: "assets/images/product11.webp",
        rating: 4.5,
        brand: "Metronaut",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 4500,
        feature: false,
    },
    {
        id: 12,
        name: "Soft Body Set of 3 Luggage - Supreme Combo Set (30inch+26inch+22inch) - Black",
        img: "assets/images/product12.webp",
        rating: 5,
        brand: "Metronaut",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 3800,
        feature: false,
    },
    {
        id: 13,
        name: "Gold Stainless Steel Case with Sport Band",
        img: "assets/images/product14.jpg",
        rating: 5,
        brand: "Apple",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 30000,
        feature: true,
    },
    {
        id: 14,
        name: "Midnight Aluminum Case with Sport Band",
        img: "assets/images/product15.jpg",
        rating: 4.5,
        brand: "Apple",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 25000,
        feature: true,
    },
    {
        id: 15,
        name: "Starlight Aluminum Case with Solo Loop",
        img: "assets/images/product16.jpg",
        rating: 4.5,
        brand: "Apple",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 20000,
        feature: false,
    },
    {
        id: 16,
        name: "Graphite Stainless Steel Case with Leather Link",
        img: "assets/images/product17.jpg",
        rating: 4.5,
        brand: "Apple",
        color: ["622060", "1437A9", "FBDADA", "519d04"],
        sizes:['xs', 's', 'm'],
        price: 20000,
        feature: false,
    },
]
module.exports = productData;